module.exports = __webpack_public_path__ + "img/mv1.af21a190.png";